import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzIconModule } from '@blk/daisy/core/icon';
import { dzMaintenance, DzPictogramsModule, dzPortfolio } from '@blk/daisy/core/pictograms';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { DataServiceModule } from '@ddt-web/data-service';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { faAngleLeft, faArrowCircleDown, faArrowCircleUp, faChartPie, faCheck, faChevronDown, faChevronUp, faFileExcel, faFileImport, faFilePdf, faInfoCircle, faPencilAlt, faPlus, faRedo, faRedoAlt, faSearch, faTasks, faTimes, faTimesCircle, faTrash, faUndo, faUndoAlt } from '@fortawesome/free-solid-svg-icons';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { HeaderMenuItemComponent } from './header-menu-item/header-menu-item.component';
import { HeaderSkeletonComponent } from './header-skeleton/header-skeleton.component';
import { HeaderComponent } from './header.component';

@NgModule({
	declarations: [HeaderComponent, HeaderMenuItemComponent, HeaderSkeletonComponent],
	imports: [
		CommonModule,
		RouterModule,
		SharedModule,
		DataServiceModule,
		CwpNgFrameworkModule,
		AnalyticsModule,
		NgxSkeletonLoaderModule,
		GenericDirectivesModule,
		DzIconModule.withIcons(
			faTimes,
			faArrowCircleUp,
			faArrowCircleDown,
			faChevronUp,
			faChevronDown,
			faInfoCircle,
			faRedo,
			faRedoAlt,
			faUndo,
			faUndoAlt,
			faTimesCircle,
			faFileImport,
			faTasks,
			faChartPie,
			faPlus,
			faPencilAlt,
			faFilePdf,
			faFileExcel,
			faTrash,
			faSearch,
			faCheck,
			faAngleLeft
		),
		DzPictogramsModule.register(dzPortfolio, dzMaintenance)
	],
	exports: [HeaderComponent, HeaderMenuItemComponent, HeaderSkeletonComponent]
})
export class HeaderModule {

}
